import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import MysteryBundleCard from 'Components/Cards/MysteryBundleCard';

const MysteryEggCard = lazy(() => import(/* webpackChunkName: "MysteryEggCard" */ 'Components/Cards/MysteryEggCard'));

const MysteryBundleCardContainer = ({ mysteryProducts, all }) => {
  const filteredProducts = mysteryProducts.filter(
    product => (product.mystery_homepage || (all && !product.mystery_upsell)),
  );

  if (isEmpty(filteredProducts)) {
    return false;
  }

  const product = filteredProducts[0];

  if (product.slug === 'mystery-egg-bundle') {
    return (
      <Suspense>
        <div className="container">
          <MysteryEggCard product={product} />
        </div>
      </Suspense>
    );
  }

  return (
    <MysteryBundleCard product={product} />
  );
};

MysteryBundleCardContainer.propTypes = {
  all: PropTypes.bool,
  mysteryProducts: PropTypes.arrayOf(PropTypes.shape({})),
};

MysteryBundleCardContainer.defaultProps = {
  mysteryProducts: [],
  all: false,
};

const mapStateToProps = ({
  mystery: { all: mysteryProducts },
}) => ({
  mysteryProducts,
});

export default connect(mapStateToProps)(MysteryBundleCardContainer);
